import { useLiquidGlassAvailability } from '@garnish/navigation';

import { useFeatureFlag } from '@order/LaunchDarkly';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Single gate for every Liquid Glass surface in the app: the rollout flag has
 * to be on and the device has to be able to render glass right now.
 */
export const useIsLiquidGlassEnabled = () => {
  const isLiquidGlassFlagEnabled = useFeatureFlag('CELS-5943-order-liquid-glass-enabled');
  const isLiquidGlassAvailable = useLiquidGlassAvailability();

  return isLiquidGlassFlagEnabled && isLiquidGlassAvailable;
};
